module.exports = __webpack_public_path__ + "img/Bingo2_Info_Game_12.70c18a13.png";